import type { NextPage } from 'next';
import HowItWorksPage from '@containers/HowItWorks';
import Head from 'next/head';

const HowItWorks: NextPage = () => {
  return (
    <>
      <Head>
        <title>
          How it works | Easiest way to get started with Indian Food | The Cumin
          Club
        </title>
      </Head>
      <HowItWorksPage />
    </>
  );
};

export default HowItWorks;
